import {EventBus} from "../../../../../common/ts/events/EventBus";
import dom, {} from "../../../../../common/ts/core/dom";
import {WhitelabelEvent} from "../../../../../common/ts/events/Events";
import {WlTextValueAdded} from "../../../../../common/ts/webcomponents/events/WlTextValueAdded";
import {
    CHIP_CONTAINER_SELECTOR,
    DISPLAYED_CSS_CLASS,
    FREE_TEXT_INPUT_CONTAINER_CONTENT_BUTTONS_SELECTOR,
    FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR,
    FREE_TEXT_INPUT_CONTAINER_SELECTOR,
    WL_TEXT_INPUT_ELEMENT
} from "./constants";
import {AddFreeTextValueEvent, ChipCloseEvent, ChipContainerUpdatedEvent} from "./events";
import eventHandlers from "./eventHandlers";

dom.init();

const eventBus: EventBus = EventBus.getInstance()
const chipContainer = dom.selectAll(CHIP_CONTAINER_SELECTOR);
const chipContainerDesktop = dom.select(FREE_TEXT_INPUT_CONTAINER_SELECTOR + " " + CHIP_CONTAINER_SELECTOR);
const desktopInput = dom.select(FREE_TEXT_INPUT_CONTAINER_SELECTOR + " " + WL_TEXT_INPUT_ELEMENT);

function init() {
    eventHandlers.init();
    handleEventsWhenInputValueAdded();
    AddHandlerWhenOnFocusInputInDesktop();

    if (!chipContainer) {
        return;
    }
    emitChipClosedEvent();
    manageVisibility();
}

function handleEventsWhenInputValueAdded() {
    const wlTextInput = dom.selectAll(WL_TEXT_INPUT_ELEMENT);

    wlTextInput.forEach((input: Element) => {
        addInputValueOnClickIcon(input);
        addInputValueOnEnterPressed(input);
    });
}

function emitChipClosedEvent() {
    chipContainer.forEach((container: Element) => {
        container.addEventListener('wl-tag-close', (event: Event) => {
            eventBus.emit(new ChipCloseEvent({containerElement: container, chip: event.target as HTMLElement}));
        });
    });
}

function addInputValueOnClickIcon(input: Element) {
    const addIcon = input?.shadowRoot?.querySelector('.icon');
    if (addIcon) {
        addIcon.addEventListener('click', () => {
            eventBus.emit(new AddFreeTextValueEvent({
                chipContainer: chipContainer,
                inputElement: input as HTMLInputElement
            }));
        });
    }
}

function addInputValueOnEnterPressed(input: Element) {
    input.addEventListener(WlTextValueAdded.type, (event: Event) => {
        const wlTextValueAddedEvent = event as WlTextValueAdded;
        eventBus.emit(new AddFreeTextValueEvent({
            chipContainer: chipContainer,
            inputElement: wlTextValueAddedEvent.input
        }));
    });
}

function AddHandlerWhenOnFocusInputInDesktop() {
    const desktopInputElement = desktopInput?.shadowRoot?.querySelector('input');
    if (desktopInputElement) {
        desktopInputElement.onfocus = () => {
            if (chipContainerDesktop && chipContainerDesktop.querySelectorAll('wl-chip').length > 0) {
                eventBus.emit(new dom.AddClassEvent({
                    selector: FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR,
                    className: DISPLAYED_CSS_CLASS
                }));
            }
        };
    }
}

function manageVisibility() {
    document.addEventListener('click', ({target}) => {
        const container = dom.select(FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR);
        const buttonsContainer = dom.select(FREE_TEXT_INPUT_CONTAINER_CONTENT_BUTTONS_SELECTOR)

        if (
            target !== container
            && container?.classList.contains(DISPLAYED_CSS_CLASS)
            && target !== chipContainerDesktop
            && target !== buttonsContainer
            && !(target instanceof HTMLElement && target.tagName === 'WL-CHIP')
            && target !== desktopInput) {
            eventBus.emit(new dom.RemoveClassEvent({
                selector: FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR,
                className: DISPLAYED_CSS_CLASS
            }));
        }
    });
}

export default {
    init,
}

